import GPSTrackingTabContent from './GPSTrackingTabContent';

export default GPSTrackingTabContent;